<div class="tab-pane show active fade details-view-results" role="tabpanel">

  <app-loading-overlay *ngIf="isLoading"></app-loading-overlay>

  @if (!isLoading) {
    <div class="diaries-tab-row">
      <ul class="nav secondary-tabs">
        @for (diary of diaries; track diary.id) {
          <li class="nav-item">
            <a class="nav-link"
               [class.active]="selectedDiaryId === diary.id"
               (click)="selectDiary(diary.id)">
              <i [class]="getDiaryTypeIcon(diary)"></i>
              {{ getDiaryDisplayName(diary) }}
            </a>
          </li>
        }
      </ul>

      <div class="add-diary-container">
        <app-button text="Diary" faIcon="fas fa-plus" variant="info" size="sm" (clicked)="onAddDiaryClick()" />
      </div>
    </div>

    @if (selectedDiaryId) {
      <app-trial-diary-form [formId]="selectedDiaryId" [isLastDiary]="diaries.length <= 1" (diaryDeleted)="onDiaryDeleted($event)" (diaryRenamed)="onDiaryRenamed($event)"></app-trial-diary-form>
    }
  }

</div>

<!-- Add Diary Modal -->
<app-modal #addDiaryModal>
  <div class="modal-header">
    <h2 class="modal-title">Add New Diary</h2>
  </div>
  <div class="modal-body">
    <form [formGroup]="addDiaryForm">
      <div class="form-group">
        <label>Diary Name <span class="required">*</span></label>
        <input type="text" class="form-control w-100" formControlName="name" placeholder="Enter diary name..." maxlength="100" />
        <span class="validation-error"
              *ngIf="addDiaryForm.get('name').touched && addDiaryForm.get('name').hasError('required')">
          Name is required.
        </span>
        <span class="validation-error"
              *ngIf="addDiaryForm.get('name').touched && addDiaryForm.get('name').hasError('whitespace')">
          Name cannot be only whitespace.
        </span>
      </div>
      <div class="form-group">
        <label>Diary Type <span class="required">*</span></label>
        <app-dropdown-input
          #diaryTypeDropdown
          [options]="diaryTypeOptions"
          [parentForm]="addDiaryForm"
          name="diaryType">
        </app-dropdown-input>
      </div>

      @if (addDiaryForm.get('diaryType').value !== null && addDiaryForm.get('diaryType').value !== DiaryType.IntraDay.toString()) {
        <div class="form-group">
          <label>Default Patient Reminder Time</label>
          <div class="input-wrap type-time">
            <mat-form-field>
              <input type="time" matInput formControlName="defaultReminderTime">
            </mat-form-field>
          </div>
        </div>
      }

      @if (addDiaryForm.get('diaryType').value === DiaryType.IntraDay.toString()) {
        <div class="form-group">
          <label>Default Patient Reminder Times</label>
          <div class="on-demand-reminder-times">
            @for (t of addDiaryDefaultIntraDayReminderTimes; track t) {
              <div class="on-demand-reminder-time-row">
                <span class="on-demand-reminder-time-value">{{ formatReminderTime(t) }}</span>
                <button type="button" class="on-demand-reminder-remove-btn" (click)="removeIntraDayReminderTime(t)" title="Remove">
                  <i class="far fa-times"></i>
                </button>
              </div>
            }
            @if (addDiaryDefaultIntraDayReminderTimes.length === 0) {
              <p class="text-muted" style="font-size:0.85rem;margin:8px 0 0 0;">No reminder times configured.</p>
            }
          </div>
          <div class="on-demand-add-row">
            <div class="input-wrap type-time">
              <mat-form-field>
                <input type="time" matInput formControlName="newIntraDayReminderTime">
              </mat-form-field>
            </div>
            <button type="button" class="btn btn-outline btn-outline-slim" (click)="addIntraDayReminderTime()" [disabled]="!addDiaryForm.get('newIntraDayReminderTime').value">Add</button>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    <div class="row w-100">
      <div class="col-6">
        <a (click)="addDiaryModal.hide()" class="btn btn-secondary w-100">Cancel</a>
      </div>
      <div class="col-6">
        <button class="btn btn-primary w-100"
                [disabled]="addDiaryForm.invalid || isCreating"
                (click)="onConfirmAddDiary()">
          <span *ngIf="isCreating">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!isCreating">Create Diary</span>
        </button>
      </div>
    </div>
  </div>
</app-modal>
